import React from "react";
import "./CareerProspects.css";

export default function CareerProspects() {
  const jobs = [
    {
      title: "Mobile Applications Developer",
      salary: "4L–8L",
      skills: "Backend computing, cybersecurity, and knowledge of UX design",
    },
    {
      title: "Software Developer",
      salary: "5L–25L",
      skills:
        "Knowledge of programming languages, proficiency in databases, and cloud computing",
    },
    {
      title: "Data Scientist",
      salary: "7L–19L",
      skills:
        "Programming languages, statistical analysis and data visualization",
    },
  ];

  return (
    <div className="career-wrapper">
      <div className="career-header">
        <h1>Growth Prospects after an Online MCA Program</h1>
        <p>
          With the increasing importance of technology and data science in
          today’s world, you can explore a plethora of splendid job
          opportunities after completing an online MCA degree.
        </p>
        <button className="btn">Get Started</button>
      </div>

      <div className="career-cards">
        {jobs.map((job, i) => (
          <div className="career-card" key={i}>
            <div className="salary-box">
              <h3>{job.salary}</h3>
              <p>per year</p>
            </div>
            <h2>{job.title}</h2>
            <p className="skills">
              <span>Skills Required:</span> {job.skills}
            </p>
          </div>
        ))}
      </div>

      <p className="note">
        *Salaries are based on data published at glassdoor.co.in
      </p>
    </div>
  );
}
